import 'react-responsive-carousel/lib/styles/carousel.min.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class Integrations extends React.Component<any, any> {
  public render() {
    console.log('Integrations', this.props)
    return (
      <div style={this.props.style}>
        {this.props.tenant.integrations.map(integration => {
          return (
            <Card style={{ height: '300px', width: '400px', display: 'inline-block' }} key={integration.name}>
              <CardActionArea onClick={this.navToIntegration(integration.path)}>
                <CardMedia image={integration.icon} style={{
                  height: '140px',
                  width: '300px'
                }} />
                <CardContent>
                  <Typography gutterBottom={true} variant="h5" component="h2">
                    {integration.text}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {integration.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })}
      </div>
    );
  }
  private navToIntegration = (key: string) => () => this.props.history.push('/console/tenants/' + this.props.tenant.id + '/integrations/' + key)
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Integrations)));



// WEBPACK FOOTER //
// ./src/sub-projects/integrations/containers/content.tsx